import { render, staticRenderFns } from "./FinishedUserTasks.vue?vue&type=template&id=ea10c6be"
import script from "./FinishedUserTasks.vue?vue&type=script&lang=ts"
export * from "./FinishedUserTasks.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports